import { Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import LayoutWithSuspense from './components/LayoutWithSuspense'
import Loading from './components/Loading'

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'))
const AboutUsPage = lazy(() => import('./pages/company/AboutUsPage'))
const PartnersPage = lazy(() => import('./pages/company/PartnersPage'))
const ContactUsPage = lazy(() => import('./pages/ContactUsPage'))
const FAQPage = lazy(() => import('./pages/FAQPage'))
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'))
const TermsPage = lazy(() => import('./pages/TermsPage'))
const CookiePolicyPage = lazy(() => import('./pages/CookiePolicyPage'))
const BookDoctorPage = lazy(() => import('./pages/BookDoctorPage'))
const ResourcesPage = lazy(() => import('./pages/ResourcesPage'))

// Products
const MedicaClinicPage = lazy(() => import('./pages/products/MedicaClinicPage'))
const MedicaReceptionPage = lazy(() => import('./pages/products/MedicaReceptionPage'))
const MedicaPatientAppPage = lazy(() => import('./pages/products/MedicaPatientAppPage'))
const MedicaPharmacyPage = lazy(() => import('./pages/products/MedicaPharmacyPage'))
const MedicaTelemedicinePage = lazy(() => import('./pages/products/MedicaTelemedicinePage'))

// Services
const SmsServicePage = lazy(() => import('./pages/service/SmsServicePage'))
const WhatsappServicePage = lazy(() => import('./pages/service/WhatsappServicePage'))
const VoiceServicePage = lazy(() => import('./pages/service/VoiceServicePage'))
const CrmServicePage = lazy(() => import('./pages/service/CrmServicePage'))
const InteractiveServicePage = lazy(() => import('./pages/service/InteractiveServicePage'))
const ValueServicePage = lazy(() => import('./pages/service/ValueServicePage'))

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<LayoutWithSuspense />}>
          <Route 
            index 
            element={<HomePage />} 
          />
        
        {/* Company Routes */}
        <Route path="company/about-us" element={<AboutUsPage />} />
        <Route path="company/partners" element={<PartnersPage />} />
        
        {/* Products Routes */}
        <Route path="products/medica-clinic" element={<MedicaClinicPage />} />
        <Route path="products/medica-reception" element={<MedicaReceptionPage />} />
        <Route path="products/medica-patient-app" element={<MedicaPatientAppPage />} />
        <Route path="products/medica-pharmacy" element={<MedicaPharmacyPage />} />
        <Route path="products/medica-telemedicine" element={<MedicaTelemedicinePage />} />
        
        {/* Service Routes */}
        <Route path="service/sms-service" element={<SmsServicePage />} />
        <Route path="service/whatsapp-service" element={<WhatsappServicePage />} />
        <Route path="service/voice-service" element={<VoiceServicePage />} />
        <Route path="service/crm-service" element={<CrmServicePage />} />
        <Route path="service/interactive-service" element={<InteractiveServicePage />} />
        <Route path="service/value-service" element={<ValueServicePage />} />
        
        {/* Other Routes */}
        <Route path="contact-us" element={<ContactUsPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="cookie-policy" element={<CookiePolicyPage />} />
        <Route path="book-doctor" element={<BookDoctorPage />} />
        <Route path="resources" element={<ResourcesPage />} />
      </Route>
    </Routes>
    </Suspense>
  )
}

export default App
